<script setup>
import {defineProps, watch} from "vue";
import Check from "../../../../franchise-listings/assets/svg/Check.svg";
import CloseModalButton from "../CloseModalButton.vue";
import debounce from "../../debounce";

const {flowState} = defineProps(['visible', 'flowState']);

const sendToHubspot = async () => {
  try {

    // Send user data to HubSpot
    // await flowState.services.submitData(flowState.userData(),function () {
    //     flowState.checkLimits();
    // });

      await flowState.services.submitData(flowState.userData());

    // Change CFF button with success message
    $('.vf-contact-form-flow-button[data-franchise-id="' + flowState.franchiseId() + '"]')
        .addClass('cff-success')
        .html('Request submitted');

      flowState.checkLimits();


  } catch (e) {
    console.log(e)
  }
};

if (flowState.getHubspotStatus()) {
  sendToHubspot()
}

const stopAndClose = () => {
  flowState.stopCountdown();
  flowState.close();
}

watch(
    () => flowState.getHubspotStatus(),
    debounce(() => {
      if (flowState.getHubspotStatus()) {
        sendToHubspot()
      }
    }, 1000)
);

</script>

<template>
  <div v-if="visible">
    <div class="tab">
      <div class="row pb-3 success-submit">
        <template v-if="flowState.getFranchiseName() !== ''">
          <p class="fw-bold congrats mb-3">
	          Your request has been submitted. A franchise specialist in our network will reach out soon.
          </p>
        </template>
        <template v-else>
          <p class="fw-bold congrats mb-3">
	          Your request has been submitted. A franchise specialist in our network will reach out soon.
          </p>
        </template>

        <p class="fw-normal">
          <Check/>
	        Please be on the lookout for a call, text, or email shortly.
        </p>
      </div>
      <div class="row mt-3">
        <div class="col-12 col-md-6 mb-3 mb-lg-0">
          <a href="/franchises/" class="btn final-button w-100 p-4">
            Search more franchises
          </a>
        </div>
        <div class="col-12 col-md-6">
          <CloseModalButton
              css-class="btn final-button w-100 p-4"
              text="Back to the listing"
              @click="() => { stopAndClose() }"
          />
        </div>
      </div>
    </div>
  </div>
</template>
